// 联盟计划申请页（Rewardful 托管），Hero 与底部 CTA 共用
export const AFFILIATE_SIGNUP_URL = 'https://erasa-dmca.getrewardful.com/signup';

// 收益计算器：设计稿 #10899:3694
// 公式 = 推荐人数 × $299/月（Elite Plan）× 6 个月 × 20% 返佣
export const ELITE_PLAN_MONTHLY_PRICE = 299;
export const COMMISSION_MONTHS = 6;
export const COMMISSION_RATE = 0.2;
// 滑块范围按需求文档与设计稿取 1–30（文案原稿写的 1–50 未同步，以设计稿为准）
export const REFERRAL_MIN = 1;
export const REFERRAL_MAX = 30;
// 刻度按设计稿等距排布，并非按数值比例定位
export const REFERRAL_TICKS = [1, 10, 20, 30];

// 真实创作者推荐（设计稿 #10899:3791 / #10899:3805），「View Post」指向原帖
export const CREATOR_POST_URLS = {
  lizzlane: 'https://x.com/lizzzlane/status/2087537440185516051',
  waiteryoshie: 'https://x.com/waiteryoshie/status/2047609875925291432',
};
export const ERASA_X_URL = 'https://x.com/Erasaprotect';

// FAQ：设计稿 #10899:3864 只画了 5 条，按文案表实现 7 条（见 docs/v1.15.0/copy/structured.md ⑦）。
// 放在 constants 而不是 Faq 组件里：页面的 FAQPage 结构化数据（faqJsonLd1）要在
// getStaticProps 里读同一份问答，两处各写一遍迟早会漂移。
// q / a 同时是 i18n 的 key —— 本页统一用英文整句作 key，未翻译的语言自然回落成英文。
export const FAQ_ITEMS = [
  {
    q: 'What subscription plans does Erasa offer?',
    a: 'Erasa offers three creator plans: Starter at $99/month, Advanced at $149/month, and Elite at $299/month. They mainly differ in monitoring coverage and service limits. Commissions are calculated based on what the referred customer actually pays.',
  },
  {
    q: 'How long are referrals tracked?',
    a: 'The referral tracking window is 30 days. If someone subscribes within 30 days of clicking your link, the qualifying purchase will be attributed to you.',
  },
  {
    q: 'How are commissions paid? Is there a minimum payout?',
    a: 'Commissions are confirmed after 30 days and paid monthly via PayPal, within 15 days of each payout cycle. There is no minimum payout.',
  },
  {
    q: 'How long can I earn from a referred customer?',
    a: 'You earn commission on their initial subscription payment and eligible renewals for up to 6 months.',
  },
  {
    q: 'What happens if a referred customer cancels or gets a refund?',
    a: 'If they cancel, no further commissions will be earned. If a payment is refunded during the 30-day confirmation period, the related commission will not be paid.',
  },
  {
    q: 'What if a customer clicks referral links from multiple affiliates?',
    a: 'The referral goes to the affiliate whose valid link the customer clicked first. Clicking another affiliate link later will not change the attribution.',
  },
  {
    q: 'Can a previous Erasa subscriber count as a new referral?',
    a: 'No. Anyone who has previously subscribed to Erasa is not eligible to be attributed as a new referral, even if they later resubscribe through another affiliate link.',
  },
];
